<template>
	<div>
		<pageheader :linkTo='linkTo'></pageheader>
		<div style="margin-top: 90px" class="partners">
			<div class="partner-title">
				<img src='../assets/partner_title_word@2x.png' />
				<div class="partner-title-content">乐骐证件照算法已支持600余种规格生成及检测服务，身份证、学历信息类更为多个政府类项目提供提供技术支持。目前已有包括携程、新华社、平安科技、杭州市民卡、华图教育、雄帝科技、厦门招生办、道克图文等超过3000加合作方接入。</div>
			</div>
			<div class="partner-category-container">
				<div v-for="item in category" class="partner-category" :key='item.index' :class="item.id==chosenCate?'chosen-partner-category':''" @click="chooseCategory(item.id)">
					<img :src="item.case_img" :title="item.category" />
					<div>{{item.category}}</div>
				</div>
			</div>
			<div class="partner-container" id="partnerFilter">
				<div class="case-content-m" v-for="item in shownPartners" :key='item.index'>
					<div class="case-content-m-list">
						<div class="case-content-m-list-pic"><img :src="item.big_logo" :alt="item.big_logo" /></div>
						<div class="com-info">
							<div class="com-logo"><img :src="item.small_logo" alt="small_logo" /></div>
							<div class="com-name">{{item.abbreviation}}</div>
						</div>
						<div class="com-str">{{item.introduction}}</div>
						<div class="line-dashed"></div>
						<div class="com-str-title">{{item.full_name}}</div>
						<div class="com-str">{{item.introduce}}</div>
					</div>
				</div>
			</div>
		</div>
		<pagefooter1></pagefooter1>
	</div>

</template>

<script>
export default {
	name: 'partner',
	metaInfo: {
		title:'最美证件照-证件照换底色-自动美颜一寸照拍摄制作平台',
		meta: [

			{ name: 'title', content: '最美证件照-证件照换底色-自动美颜一寸照拍摄制作平台' },
			{ name: 'description', content:'最美证件照-在线证件照换底色,专业的一寸证件照在线拍摄软件.涵盖海量证件照尺寸,包含计算机等级考试,四六级,国考,会计,教师资格证考试报名照片,简历照,工作证等各类尺寸.智能图片裁剪,多套正装模板自动贴合人像.'},
			{ name: 'keywords', content:'证件照换底色,证件照尺寸,证件照,最美证件照,一寸照'},
		]
	},
	data(){
		return {
			category:[
				{id:'1',case_img:require('../assets/icon_online_nomal@2x.png'),category:'签证'},
				{id:'2',case_img:require('../assets/icon_life_nomal@2x.png'),category:'社保/驾驶'},
				{id:'3',case_img:require('../assets/icon_test_nomal@2x.png'),category:'考试报名'},
				{id:'4',case_img:require('../assets/icon_foreign_nomal@2x.png'),category:'出入境'},
				{id:'5',case_img:require('../assets/icon_photographic_nomal@2x.png'),category:'相馆/图文'},
				{id:'6',case_img:require('../assets/icon_print_nomal@2x.png'),category:'云打印'},
				{id:'7',case_img:require('../assets/icon_people_nomal@2x.png'),category:'人力资源'},
				{id:'8',case_img:require('../assets/icon_other_nomal@2x.png'),category:'其他类别'},
			],
			chosenCate:1,
			shownPartners:[],
		}
	},
	created() {
		this.getCategorizedPartners(1)
		this.linkTo=this.$route.path.substr(1)
	},
	methods:{
		chooseCategory:function(e){
			this.chosenCate=e;
			this.getCategorizedPartners(e)
		},
		getCategorizedPartners:function(id){
			this.axios.get(`https://apicall.id-photo-verify.com/api/get_success_company_info/${id}`).then((response) => {
				console.log(response.data)
				if(response.data.code==200){
					this.shownPartners=response.data.company_list
				}
			})
		}
	}
}
</script>

<style>
	.partners>div{
		padding: 0 19%;
		box-sizing: border-box;
	}
	.partner-title{
		background: url('../assets/case_bg_image.png') no-repeat;
		background-size: cover;
		height: 500px;
		width: 100%;
	}
	.partner-title>img{
		width: 416px;
		height: 84px;
		margin-top: 105px;
	}
	.partner-title-content{
		width:499px;
		font-size:18px;
		color:rgba(102,102,102,1);
		line-height:32px;
		margin-top: 40px;
	}
	.partner-category-container{
		box-sizing: border-box;
		width: 1200px;
		height: 120px;
		margin: 0 auto;
		box-shadow:0px 15px 30px 0px rgba(228,228,228,0.5);
		border-radius:2px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		position: relative;
		background-color: #FFFFFF;
		bottom:67px
	}
	.partner-category{
		width: 136px;
		height: 136px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		flex-grow: 1;
		flex-shrink: 0;
		cursor: pointer;
	}
	.partner-category img{
		filter: grayscale(1);
		width: 50px;
		height: 50px;
	}
	.partner-category div{
		font-size:16px;
		font-weight:400;
		color:#333333;
		margin-top: 10px;
	}
	.chosen-partner-category img{
		filter: grayscale(0);
	}
	.chosen-partner-category div{
		font-size:16px;
		font-weight:400;
		color:#FF7BAC;
		margin-top: 10px;
	}
	.partner-container {
		width: 1176px;
		min-height: 82vh;
		margin: 0 auto;
		padding: 0 !important;
	}
	.case-content-m{
		height:603px;
		width: 388px;
		/* background: url('../assets/case-bg-1.png') no-repeat; */
		display: inline-block;
		vertical-align: top;
	}
	.case-content-m-list{
		margin: 2.3em 2.75em;
		position: relative;
	}
	.case-content-m-list-pic{

	}
	.case-content-m-list-pic img{
		width:267.6px;
		margin: 1em;
	}

	.com-info{
		margin: 0 1em;
		display: inline-flex;
		align-items: center;
	}
	.com-logo{

	}
	.com-logo img{
		width: 2.6em;
		height: 2.6em;
	}
	.com-name{
		font-size: 16px;
		color: #353E47;
		letter-spacing: 0.75px;
		margin-left: 1em;
	}
	.com-str{
		margin: 0em 1.2em;
		font-size: 14px;
		color: #7D8A95;
		letter-spacing: 0.58px;
	}
	.com-str-title{
		font-size: 16px;
		color: #353E47;
		letter-spacing: 0.75px;
		margin: 0.5em 1em;
	}
	.line-dashed{
		margin: 1em;
		border-top: 1px dashed #979797;
	}
</style>
